import makeStyles from '@mui/styles/makeStyles';

export const createClasses = makeStyles(theme => ({
  heading: {
    maxWidth: '450px',
    marginBottom: theme.spacing(4),
    '& span': {
      color: theme.palette.secondary[500]
    }
  },

  inputLabel: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1.5)
  },

  inputCopy: {
    width: '100%'
  }
}));
